import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePost } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import parseError from "../../../utils/parseError";
export const useUpdatePost = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updatePostMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updatePost(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Post updated successfully");
            queryClient.invalidateQueries(["posts"]);
            queryClient.invalidateQueries(["post"]); // invalidate specific post details if cached
            navigate("/blog/posts");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update post");
        },
    });

    return { updatePostMutate, isUpdating };
};
